import { skipToken } from "@reduxjs/toolkit/query";
import { useGetProposalForRenewQuery } from "../../../api/gms/proposal/proposal-api";
import { getErrorMessage } from "../../../utils/get-error-message.utils";
import { useGetUserInfoQuery } from "../../../api/user/user-api";
import { useGetRequestAmendmentsLogsQuery } from "../../../api/request-amendment/request-amendment-api";

interface Props {
    sECRegisteredNameRenew?: string | null;  
    shouldCheckCompany?: boolean;  
    debouncedGroupName?: string;  
    currentId?: number | null;  
    currentProposalId?: number | null;  
    proposalIdAmendment?: number | null;
}

export const useDynamicQuires = ({ sECRegisteredNameRenew, debouncedGroupName, currentId, currentProposalId, proposalIdAmendment }: Props) => {

    const shouldCheckCompany = !!debouncedGroupName?.trim();
    const queryArg = shouldCheckCompany ? { groupName: debouncedGroupName! } : skipToken;
    const userDataQueryArg = currentId ? { userId: currentId } : skipToken;
    const amendmentHistoryQueryArg = proposalIdAmendment != null ? { proposalId: proposalIdAmendment } : skipToken;
    
    const { data: proposalForRenew, isLoading: isLoadingProposalForRenew, isError: isErrorProposalForRenew, error: errorProposalForRenew, refetch: refetchProposalForRenew, isFetching: isFetchingProposalForRenew } = useGetProposalForRenewQuery({ secName: sECRegisteredNameRenew ?? "" }, { skip: !sECRegisteredNameRenew });
    const errorMessageProposalForRenew = getErrorMessage(errorProposalForRenew)
    
    // const { data: existingCompany, isLoading: isLoadingExistingCompany, isError: isErrorExistingCompany, error: errorExistingCompany, refetch: refetchExistingCompany, isFetching: isFetchingExistingCompany } = useGetIsExistingCompanyProposalQuery(queryArg)
    // const errorMessageExistingCompany = getErrorMessage(errorExistingCompany)
    
    const { data: userData, isLoading: isLoadingUserData, isError: isErrorUserData, error: errorUserData, refetch: refetchUserData, isFetching: isFetchingUserData } = useGetUserInfoQuery(userDataQueryArg)
    const errorMessageUserData = getErrorMessage(errorUserData)
    
    // const { data: groupMessages, isLoading: isLoadingGroupMessages, isError: isErrorGroupMessages, error: errorGroupMessages, refetch: refetchGroupMessages, isFetching: isFetchingGroupMessages } = useGetGroupChatProposalQuery({ proposalID: currentProposalId as number },{ skip: currentProposalId === null, refetchOnMountOrArgChange: true })
    // const errorMessageGroupMessages = getErrorMessage(errorGroupMessages)
    
    const { data: getAmendmentHistoryLogs, isLoading: isLoadingGetAmendmentHistoryLogs, isError: isErrorGetAmendmentHistoryLogs, error: errorGetAmendmentHistoryLogs, refetch: refetchGetAmendmentHistoryLogs, isFetching: isFetchingGetAmendmentHistoryLogs } = useGetRequestAmendmentsLogsQuery(amendmentHistoryQueryArg)
    const errorMessageGetAmendmentHistoryLogs = getErrorMessage(errorGetAmendmentHistoryLogs)

    return {
        proposalForRenew,
        isLoadingProposalForRenew,
        isErrorProposalForRenew,
        errorProposalForRenew,
        refetchProposalForRenew,
        isFetchingProposalForRenew,
        errorMessageProposalForRenew,

        // existingCompany,
        // isLoadingExistingCompany,
        // isErrorExistingCompany,
        // errorExistingCompany,
        // refetchExistingCompany,
        // isFetchingExistingCompany,
        // errorMessageExistingCompany,

        userData,
        isLoadingUserData,
        isErrorUserData,
        errorUserData,
        refetchUserData,
        isFetchingUserData,
        errorMessageUserData,

        // groupMessages,
        // isLoadingGroupMessages,
        // isErrorGroupMessages,
        // errorGroupMessages,
        // refetchGroupMessages,
        // isFetchingGroupMessages,
        // errorMessageGroupMessages,

        getAmendmentHistoryLogs,
        isLoadingGetAmendmentHistoryLogs,
        isErrorGetAmendmentHistoryLogs,
        errorGetAmendmentHistoryLogs,
        refetchGetAmendmentHistoryLogs,
        isFetchingGetAmendmentHistoryLogs,
        errorMessageGetAmendmentHistoryLogs,
    }
}